export const data = {
  area: '上海',
  jg: '机构类型筛选',
  jgtext: '法律服务机构',
  qy: '区域筛选',
  jd: '街道筛选',
  number: '',
  stract: [],
  stractname: '',
  cod: '',
  tpid: '1309ace1040f457cb27f48d3b66e13cf',
  towncode: '',
  totname: '',
  standbynumber: '',
  pagenum: 1,
  zoomCode: [],
  geli: false,
  resuList: [],
  typename: [
    {id: '7454a420f4ef4e539c1b9b4e30e8f6e7', name: '人民调解委员会'},
    {id: 'cf2ec647762641e897c0d1fd7f474141', name: '律师事务所'},
    {id: 'f2c12d3fe56845c79154dea5a90c8bb1', name: '公证处'},
    {id: 'bf6f10555f54425483df978649473325', name: '法援助机构'},
    {id: '6943237e1b2948afb6625abd7f86ac7e', name: '司法鉴定'}
  ],
  accurate: {name: '', j: '', w: '', address: '', zc: ''},
  tpage: 0,
  show: false,
  sshow: false,
  showstr: false,
  titNumber: false,
  innbool: false,
  qu: false,
  qua: false,
  qub: false,
  quc: false,
  toback: false,
  maplod: false,
  lodingbox: true,
  map: null,
  infowindow: null,
  stractt: [],
  strctt: [],
  markers: [],
  lawyerMarkers: [],
  searchMarkers: [],
  focusList: 0,
  focusListNwe: 0,
  detailnum: '',
  result: [],
  codCount: [],
  zooLCode: [],
  zoomResult: '',
  resuDetail: [],
  search: '',
  searchara: [],
  screening: [],
  screeninga: [],
  screeningb: [],
  gasValve: true,
  lodshow: false,
  getLawyer: '',
  addMarker: '',
  addMarkers: '',
  addMarkerp: '',
  createWindow: '',
  zoomStract: '',
  zoomCityShow: '',
  jgshow: true,
  lxshow: true,
  kkkaaa: true,
  focushow: false,
  butshow: false,
  appindex: '',
  nuab: '',
  createStreetData: '',
  mapLine: '',
  myPosition: '', // 我的位置,
  newAuto: '',
  newAutoArr: '',
  oneSw: true,
  twoSw: false,
  newAShow: false,
  gePosition: [0, 0] // 是否地理位置筛选
}

import AMap from 'AMap'
export const created = function () {
  let self = this
  this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1', { // 获取初始数据
    towncode: '' + this.towncode + '',
    callbackQuery: 'jsonp',
    callbackName: 'jsonp',
    typeId: '' + this.tpid + ''
  }).then(json => {
    let allnum = 0
    let len = json.length
    this.zoomCode = json
    this.titNumber = true
    for (let i = 0; i < len; i++) {
      this.number = allnum += json[i].count
      this.standbynumber = this.number
    }
    let map = []
    let district = []
    let polygons = []
    this.map = map = new AMap.Map('lawmap', {
      resizeEnable: true,
      zooms: [11, 18],
      showIndoorMap: false,
      animateEnable: false,
      doubleClickZoom: false,
      keyboardEnable: false
    })
    map.plugin(['AMap.ToolBar'], () => {
      let tool = new AMap.ToolBar({
        liteStyle: true,
        locate: true
      })
      map.addControl(tool)
    })
    let opts = {
      subdistrict: 2,
      level: 'city',
      extensions: 'all',
      showbiz: false
    }

    // map.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], () => {
    //   let autoOptions = {
    //     city: '上海',
    //     input: 'tipinput'
    //   }
    //   let auto = new AMap.Autocomplete(autoOptions)
    //   AMap.event.addListener(auto, 'select', (e) => {
    //     self.stractname = e.poi.name
    //     self.cod = ''  // 清空code
    //     self.tpid = '' // 清空code
    //     if (e.poi.location === undefined) {
    //       return
    //     }
    //     let position = [e.poi.location.M, e.poi.location.O]
    //     self.myPosition = position
    //     self.map.setZoomAndCenter(16, position)
    //     self.$jsonp(`https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/orgnearby?longitude=${e.poi.location.M}&latitude=${e.poi.location.O}`, {
    //       callbackQuery: 'jsonp',
    //       callbackName: 'jsonp',
    //       pageSize: '15'
    //     }).then(json => {
    //       self.number = json.length
    //       self.tpage = 0
    //       self.abaInner(json)
    //       self.addMarkerp(json)
    //       let icon = new AMap.Icon({
    //         image: 'static/images/mark_local.png',
    //         size: new AMap.Size(25, 36)
    //       })
    //       let marker = new AMap.Marker({
    //         icon: icon,
    //         position: position,
    //         topWhenMouseOver: true,
    //         map: map
    //       })
    //       self.lawyerMarkers.push(marker)
    //     })
    //   })
    //   手动搜索
    self.newAuto = function (val) {
      return new Promise((resolve, reject) => {
        map.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], () => {
          let autoOptions = {
            city: '上海'
          }
          let auto = new AMap.Autocomplete(autoOptions)
          auto.search(val, function (e, o) {
            if (o.info === 'OK') {
              resolve(o)
            }
          })
        })
      })
    }
    map.plugin('AMap.Geolocation', function () {
      let geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 10000,           // 超过10秒后停止定位，默认：无穷大
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true,       // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        buttonPosition: 'RB'
      })
      map.addControl(geolocation)
      // geolocation.getCurrentPosition() // 这个是一进来就要定位的哦！！
      AMap.event.addListener(geolocation, 'complete', onComplete) // 返回定位信息
      AMap.event.addListener(geolocation, 'error', onError)       // 返回定位出错信息
      setTimeout(() => {
        self.clear()
        document.querySelector('.amap-geo.amap-toolbar-geo').style.display = 'none'
        document.querySelector('.amap-zoomcontrol').style.display = 'none'
        self.lodingbox = false
      }, 500)
    })
    // 解析定位结果
    function onComplete (data) {
      self.stractname = data.formattedAddress
      let position = [data.position.getLng(), data.position.getLat()]
      self.myPosition = position
      self.gePosition = position
      let str = ['定位成功']
      str.push('经度：' + data.position.getLng())
      str.push('纬度：' + data.position.getLat())
      if (data.accuracy) {
        str.push('精度：' + data.accuracy + ' 米')
      } // 如为IP精确定位结果则没有精度信
      str.push('是否经过偏移：' + (data.isConverted ? '是' : '否'))
      self.$jsonp(`https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/orgnearby?longitude=${data.position.getLng()}&latitude=${data.position.getLat()}`, {
        callbackQuery: 'jsonp',
        callbackName: 'jsonp',
        typeId: self.tpid,
        pageSize: '15'
      }).then(json => {
        self.area = json[0].properties.zoneName
        self.number = json.length
        self.cod = ''
        self.tpid = '1309ace1040f457cb27f48d3b66e13cf'
        self.tpage = 0
        self.abaInner(json)
        self.addMarker(json)
        let icon = new AMap.Icon({
          image: 'static/images/mark_local.png',
          size: new AMap.Size(25, 36)
        })
        let marker = new AMap.Marker({
          icon: icon,
          position: position,
          topWhenMouseOver: true,
          map: map
        })
        self.lawyerMarkers.push(marker)
        document.querySelector('.amap-marker').style.display = 'none'
        if (json.length >= 1) {
          let contJson = json[0]
          let inner = contJson.properties.name
          let address = contJson.properties.address
          let phone = contJson.properties.phone
          let position = '' + contJson.properties.longitudeGD + ',' + contJson.properties.latitudeGD + ''
          let tpid = contJson.typeId
          let id = contJson.id
          let tpname = contJson.typeName
          self.createWindow({
            inner: inner, // 名字
            address: address, // 地址
            phone: phone, // 电话
            tpid: tpid, // 机构类型
            id: id, // id
            tpname: tpname // 机构类型名称
          }, self)
          self.infowindow.open(self.map, position.split(','))
        }
      })
      // document.getElementById('tip').innerHTML = str.join('<br>')
    }
    // 解析定位错误信息
    function onError (data) {
      document.getElementById('tip').innerHTML = '定位失败'
    }
    district = new AMap.DistrictSearch(opts)
    function createMark (obj, className, name, num, code) {
      if (code) {
        obj.setAttribute('data-code', code)
        obj.className = className
        obj.innerHTML = name + '<br /> ' + num
        return obj
      }
    }
    function setBounds (data) {
      if (data) {
        let l = data.length
        for (let i = 0; i < l; i++) {
          let polygon = new AMap.Polygon({
            map: map,
            strokeWeight: 3,
            strokeColor: '#ff4240',
            fillOpacity: 0,
            strokeOpacity: 0.7,
            path: data[i]
          })
          polygons.push(polygon)
        }
      }
    }
    function removeBounds () {
      let l = polygons.length
      for (let i = 0; i < l; i++) {
        polygons[i].setMap(null)
      }
    }
    function createDis () {
      for (let i = 0; i < this.zoomCode.length; i++) {
        let div = document.createElement('div')
        let name = this.zoomCode[i].name
        let num = this.zoomCode[i].count
        let code = this.zoomCode[i].code
        if (this.zoomCode[i].longitudeGD) {
          let districtCenter = [this.zoomCode[i].longitudeGD, this.zoomCode[i].latitudeGD]
          createMark(div, 'circle', name, num, code)
          div.setAttribute('data-index', i)
          div.setAttribute('data-name', this.zoomCode[i].name)
          div.setAttribute('data-num', this.zoomCode[i].count)
          div.setAttribute('data-position', districtCenter)
          let marker = new AMap.Marker({
            content: div,
            position: districtCenter,
            topWhenMouseOver: true,
            map: map
          })
          marker.name = name
          marker.districtCenter = districtCenter
          this.markers.push(marker)
          div.onmouseover = function () {
            let circleData = this.getAttribute('data-code')
            removeBounds()
            district.search(circleData, (status, result) => {
              if (status === 'complete') {
                setBounds(result.districtList[0].boundaries)
              }
            })
          }
          div.onmouseout = function () {
            removeBounds()
          }
          div.onclick = function () {
            self.gePosition = [0, 0]
            let code = this.getAttribute('data-code')
            let position = this.getAttribute('data-position')
            let index = this.getAttribute('data-index')
            let num = this.getAttribute('data-num')
            let name = this.getAttribute('data-name')
            self.sho(index, self.zoomCode[index], num, code, name)
            console.log(createStreet)
            self.showstr = false
            self.sshow = false
            self.show = true
            self.map.setZoomAndCenter(16, position.split(','))
          }
        }
      }
    }
    self.zoomCityShow = createDis
    self.createWindow = function (opts, _this) {
      opts = opts || {}
      let inner = opts.inner || ''
      let address = opts.address || '暂无地址'
      let id = opts.id || ''
      let tpname = opts.tpname || ''
      let phonelen = opts.phone.length
      let phone
      let serviceLink
      if (phonelen > 8) {
        phone = opts.phone.replace(/(^s*)|(s*$)/g, '') || ''
      } else {
        phone = '021-' + opts.phone.replace(/(^s*)|(s*$)/g, '') || ''
      }
      if (tpname === '律师事务所') {
        serviceLink = 'service/service-lawyer.jsp'
      } else if (tpname === '人民调解委员会') {
        serviceLink = 'service/service-mediation.jsp'
      } else if (tpname === '公证处') {
        serviceLink = 'service/service-notarization.jsp'
      } else if (tpname === '法援机构') {
        serviceLink = 'service-help.jsp'
      } else {
        serviceLink = ''
      }
      // console.log(serviceLink)
      // let titname = ''
      let infoWindowContent = '<div class="card">' +
                              '<div class="card-heading">' +
                              '<div class="tag">' + tpname + '</div>' +
                              // '<a class="readmore" href="//sh.12348.gov.cn/sites/12348/detail/subject-detail.jsp?id=' + id + '" target="_blank">了解更多</a>' +
                              '</div>' +
                              '<div class="card-body"> ' +
                              '<div class="title">' +
                                '<span>' + inner + '</span>' +
                                '<a class="title-a" href="//sh.12348.gov.cn/sites/12348/detail/subject-detail.jsp?id=' + id + '" target="_blank">查看详情</a>' +
                              '</div>' +
                              '<ul class="card-filter">' +
                              '<li class="card-item">' +
                              '<div class="count">0</div><div class="text">规模</div>' +
                              '</li>' +
                              '<li class="card-item">' +
                              '<div class="count">0</div><div class="text">公益指数</div>' +
                              '</li>' +
                              '<li class="card-item">' +
                              '<div class="count">0</div><div class="text">信用指数</div>' +
                              '</li>' +
                              '<li class="card-item">' +
                              '<div class="count">0</div><div class="text">好评率</div>' +
                              '</li>' +
                              '</ul>' +
                              '<ul class="card-btns">' +
                              '<li>' +
                              '<a class="card-btn card-btn-1" href="//sh.12348.gov.cn/sites/12348/zxspace/text-detail.jsp?entityId=8969156b86634bc994500b0561e7fa77" target="_blank">我要咨询</a>' +
                              '</li>' +
                              '<li>' +
                              '<a class="card-btn card-btn-2" href="//sh.12348.gov.cn/sites/12348/' + serviceLink + '" target="_blank">在线预约</a>' +
                              '</li>' +
                              '<li>' +
                              '<a class="card-btn card-btn-3" href="https://sh.12348.gov.cn/sites/12348/detail/subject-detail.jsp?id=' + id + '" target="_blank">信用信息</a>' +
                              '</li>' +
                              '</ul>' +
                              '<div class="tel-phone-box">' +
                              '<div class="tel-phone-title"><i class="iconfont icon-tel"></i>服务电话</div>' +
                              '<div class="tel-phone">' + phone + '</div>' +
                              '</div>' +
                              '<div class="desc"><i class="iconfont icon-local"></i>' + address + '</div> ' +
                              '</div>' +
                              '</div>'
      _this.map.plugin('AMap.AdvancedInfoWindow', () => {
        _this.infowindow = new AMap.AdvancedInfoWindow({
          placeSearch: false,
          content: infoWindowContent,
          offset: new AMap.Pixel(0, -30)
        })
      })
    }
    self.addMarker = function (json) {
      map.remove(self.lawyerMarkers)
      if (!json) {
        return
      }
      let pss
      if (json.length !== 0 && json[0].properties.longitudeGD) {
        pss = [json[0].properties.longitudeGD, json[0].properties.latitudeGD]
      }
      self.map.setZoomAndCenter(16, pss)
      for (let i = 0; i < json.length; i++) {
        let div = document.createElement('div')
        let districtCenter
        var markName
        switch (json[i].typeId) {
          case '6943237e1b2948afb6625abd7f86ac7e':
            markName = 'sj'
            break
          case 'f2c12d3fe56845c79154dea5a90c8bb1':
            markName = 'gz'
            break
          case 'bf6f10555f54425483df978649473325':
            markName = 'fy'
            break
          case '7454a420f4ef4e539c1b9b4e30e8f6e7':
            markName = 'rm'
            break
          case 'cf2ec647762641e897c0d1fd7f474141':
            markName = 'ls'
            break
        }
        if (json[i].properties.longitudeGD) {
          districtCenter = [json[i].properties.longitudeGD, json[i].properties.latitudeGD]
        }
        createMark(div, 'dot', ' ', ' ', ' ')
        div.setAttribute('data-inner', json[i].properties.name)
        div.setAttribute('data-position', districtCenter)
        div.setAttribute('data-address', json[i].properties.address)
        div.setAttribute('data-phone', json[i].properties.phone)
        div.setAttribute('data-tpid', json[i].typeId)
        div.setAttribute('data-id', json[i].id)
        div.setAttribute('data-tpname', json[i].typeName)
        div.setAttribute('class', 'dot ' + markName)
        let marker = new AMap.Marker({
          content: div,
          position: districtCenter,
          topWhenMouseOver: true,
          map: map
        })
        self.lawyerMarkers.push(marker)
        div.onclick = function () {
          let inner = this.getAttribute('data-inner')
          let address = this.getAttribute('data-address')
          let phone = this.getAttribute('data-phone')
          let position = this.getAttribute('data-position')
          let tpid = this.getAttribute('data-tpid')
          let id = this.getAttribute('data-id')
          let tpname = this.getAttribute('data-tpname')
          self.createWindow({
            inner: inner, // 名字
            address: address, // 地址
            phone: phone, // 电话
            tpid: tpid, // 机构类型
            id: id, // id
            tpname: tpname // 机构类型名称
          }, self)
          self.infowindow.open(map, position.split(','))
        }
      }
    }
    self.addMarkerp = function (json) {
      map.remove(self.lawyerMarkers)
      if (!json) {
        return
      }
      for (let i = 0; i < json.length; i++) {
        let div = document.createElement('div')
        let districtCenter
        var markName
        switch (json[i].typeId) {
          case '6943237e1b2948afb6625abd7f86ac7e':
            markName = 'sj'
            break
          case 'f2c12d3fe56845c79154dea5a90c8bb1':
            markName = 'gz'
            break
          case 'bf6f10555f54425483df978649473325':
            markName = 'fy'
            break
          case '7454a420f4ef4e539c1b9b4e30e8f6e7':
            markName = 'rm'
            break
          case 'cf2ec647762641e897c0d1fd7f474141':
            markName = 'ls'
            break
        }
        if (json[i].properties.longitudeGD) {
          districtCenter = [json[i].properties.longitudeGD, json[i].properties.latitudeGD]
        }
        createMark(div, 'dot', ' ', ' ', ' ')
        div.setAttribute('data-inner', json[i].properties.name)
        div.setAttribute('data-position', districtCenter)
        div.setAttribute('data-address', json[i].properties.address)
        div.setAttribute('data-phone', json[i].properties.phone)
        div.setAttribute('data-tpid', json[i].typeId)
        div.setAttribute('data-id', json[i].id)
        div.setAttribute('data-tpname', json[i].typeName)
        div.setAttribute('class', 'dot ' + markName)
        let marker = new AMap.Marker({
          content: div,
          position: districtCenter,
          topWhenMouseOver: true,
          map: map
        })
        self.lawyerMarkers.push(marker)
        div.onclick = function () {
          self.gePosition = [0, 0]
          let inner = this.getAttribute('data-inner')
          let address = this.getAttribute('data-address')
          let phone = this.getAttribute('data-phone')
          let position = this.getAttribute('data-position')
          let tpid = this.getAttribute('data-tpid')
          let id = this.getAttribute('data-id')
          let tpname = this.getAttribute('data-tpname')
          self.createWindow({
            inner: inner,
            address: address,
            phone: phone,
            tpid: tpid,
            id: id,
            tpname: tpname
          }, self)
          self.infowindow.open(map, position.split(','))
        }
      }
    }
    self.addMarkers = function (json) {
      if (!json) {
        return
      }
      let pss
      if (json[0].properties.longitudeGD) {
        pss = [json[0].properties.longitudeGD, json[0].properties.latitudeGD]
      }
      self.map.setZoomAndCenter(16, pss)
      for (let i = 0; i < json.length; i++) {
        let div = document.createElement('div')
        let districtCenter
        var markName
        switch (json[i].typeId) {
          case '6943237e1b2948afb6625abd7f86ac7e':
            markName = 'sj'
            break
          case 'f2c12d3fe56845c79154dea5a90c8bb1':
            markName = 'gz'
            break
          case 'bf6f10555f54425483df978649473325':
            markName = 'fy'
            break
          case '7454a420f4ef4e539c1b9b4e30e8f6e7':
            markName = 'rm'
            break
          case 'cf2ec647762641e897c0d1fd7f474141':
            markName = 'ls'
            break
        }
        if (json[i].properties.longitudeGD) {
          districtCenter = [json[i].properties.longitudeGD, json[i].properties.latitudeGD]
        }
        createMark(div, 'dot', ' ', ' ', ' ')
        div.setAttribute('data-inner', json[i].properties.name)
        div.setAttribute('data-position', districtCenter)
        div.setAttribute('data-address', json[i].properties.address)
        div.setAttribute('data-phone', json[i].properties.phone)
        div.setAttribute('data-tpid', json[i].typeId)
        div.setAttribute('data-id', json[i].id)
        div.setAttribute('data-tpname', json[i].typeName)
        div.setAttribute('class', 'dot ' + markName)
        let marker = new AMap.Marker({
          content: div,
          position: districtCenter,
          topWhenMouseOver: true,
          map: map
        })
        self.lawyerMarkers.push(marker)
        div.onclick = function () {
          self.gePosition = [0, 0]
          let inner = this.getAttribute('data-inner')
          let address = this.getAttribute('data-address')
          let phone = this.getAttribute('data-phone')
          let position = this.getAttribute('data-position')
          let tpid = this.getAttribute('data-tpid')
          let id = this.getAttribute('data-id')
          let tpname = this.getAttribute('data-tpname')
          self.createWindow({
            inner: inner,
            address: address,
            phone: phone,
            tpid: tpid,
            id: id,
            tpname: tpname
          }, self)
          self.infowindow.open(map, position.split(','))
        }
      }
    }
    self.getLawyer = function (towncode) {
      self.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?page=-1&', {
        callbackQuery: 'jsonp',
        towncode: '' + towncode + ''
      }).then(json => {
        if (!json) {
          return
        }
        for (let i = 0; i < json.length; i++) {
          let div = document.createElement('div')
          let districtCenter
          if (json[i].properties.longitudeGD) {
            districtCenter = [json[i].properties.longitudeGD, json[i].properties.latitudeGD]
          }
          createMark(div, 'dot', ' ', ' ', ' ')
          div.setAttribute('data-inner', json[i].properties.name)
          div.setAttribute('data-position', districtCenter)
          div.setAttribute('data-address', json[i].properties.address)
          div.setAttribute('data-phone', json[i].properties.phone)
          div.setAttribute('data-tpid', json[i].typeId)
          div.setAttribute('data-id', json[i].id)
          div.setAttribute('data-tpname', json[i].typeName)
          let marker = new AMap.Marker({
            content: div,
            position: districtCenter,
            topWhenMouseOver: true,
            map: map
          })
          self.lawyerMarkers.push(marker)
          div.onclick = function () {
            self.gePosition = [0, 0]
            let inner = this.getAttribute('data-inner')
            let address = this.getAttribute('data-address')
            let phone = this.getAttribute('data-phone')
            let position = this.getAttribute('data-position')
            let tpid = this.getAttribute('data-tpid')
            let id = this.getAttribute('data-id')
            let tpname = this.getAttribute('data-tpname')
            self.createWindow({
              inner: inner,
              address: address,
              phone: phone,
              tpid: tpid,
              id: id,
              tpname: tpname
            }, self)
            self.infowindow.open(map, position.split(','))
          }
        }
      })
    }
    self.createStreetData = function (json) {
      if (!json) {
        return
      }
      for (let i = 0; i < json.length; i++) {
        let div = document.createElement('div')
        let name = json[i].name
        let num = json[i].count
        let code = json[i].code
        let districtCenter
        if (json[i].longitudeGD) {
          districtCenter = [json[i].longitudeGD, json[i].latitudeGD]
        }
        createMark(div, 'stract', name, num, code)
        div.setAttribute('data-position', districtCenter)
        div.setAttribute('data-positionL', json[i].longitudeGD)
        div.setAttribute('data-positionS', json[i].latitudeGD)
        div.setAttribute('data-name', name)
        div.setAttribute('data-item', json[i])
        div.setAttribute('data-num', num)
        div.setAttribute('data-index', i)
        let marker = new AMap.Marker({
          content: div,
          position: districtCenter,
          topWhenMouseOver: true,
          map: map
        })
        marker.name = name
        marker.districtCenter = districtCenter
        self.lawyerMarkers.push(marker)
        div.onclick = function () {
          self.gePosition = [0, 0]
          let towncode = this.getAttribute('data-code')
          let name = this.getAttribute('data-name')
          let item = this.getAttribute('data-item')
          let num = this.getAttribute('data-num')
          let index = this.getAttribute('data-index')
          let pL = this.getAttribute('data-positionL')
          let pS = this.getAttribute('data-positionS')
          let arrPl = JSON.parse('[' + pL + ' , ' + pS + ']')
          map.remove(self.lawyerMarkers)
          self.jd = name
          self.aba(towncode, num, name, index, item, arrPl)
        }
      }
    }
    function createStreet (code) {
      self.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
        callbackQuery: 'jsonp',
        zoneCode: '' + code + '',
        towncode: '' + this.towncode + '',
        typeId: '' + self.tpid + ''
      }).then(json => {
        if (!json) {
          return
        }
        for (let i = 0; i < json.length; i++) {
          let div = document.createElement('div')
          let name = json[i].name
          let num = json[i].count
          let code = json[i].code
          let districtCenter
          if (json[i].longitudeGD) {
            districtCenter = [json[i].longitudeGD, json[i].latitudeGD]
          }
          createMark(div, 'stract', name, num, code)
          div.setAttribute('data-position', districtCenter)
          let marker = new AMap.Marker({
            content: div,
            position: districtCenter,
            topWhenMouseOver: true,
            map: map
          })
          marker.name = name
          marker.districtCenter = districtCenter
          self.lawyerMarkers.push(marker)
          div.onclick = function () {
            let towncode = this.getAttribute('data-code')
            let position = this.getAttribute('data-position')
            map.remove(self.lawyerMarkers)
            self.getLawyer(towncode)
            self.map.setZoomAndCenter(16, position.split(','))
          }
        }
      })
    }
    function mapZoomShowCir () {
      AMap.event.addListener(map, 'zoomend', function (e) {
        switch (getMapZoom()) {
          case 11:
          case 12:
            self.pagenum = 1
            self.geli = false
            self.resuList = []
            self.totname = ''
            self.jd = ''
            self.towncode = ''
            self.search = ''
            self.stractname = ''
            self.stract = []
            self.stractt = []
            self.show = false
            self.sshow = false
            self.showstr = false
            self.area = '上海'
            self.number = self.standbynumber
            self.cod = ''
            self.tpid = '1309ace1040f457cb27f48d3b66e13cf'
            self.gePosition = [0, 0]
            self.qy = '区域筛选'
            self.jg = '机构类型筛选'
            self.lodshow = false
            self.qu = false
            self.qub = false
            self.quc = false
            self.jgshow = true
            self.lxshow = true
            self.tpage = 0
            self.nuab = ''
            self.toback = false
            self.maplod = false
            self.newAutoArr = []
            self.oneSw = true
            self.twoSw = false
            self.newAShow = false
            removeBounds()
            map.remove(self.markers)
            map.remove(self.lawyerMarkers)
            self.zoomCityShow()
            break
          case 13:
            break
          case 14:
            removeBounds()
            self.map.remove(self.markers)
            self.map.remove(self.lawyerMarkers)
            self.createStreetData(self.stract)
            break
          case 15:
            removeBounds()
            map.remove(self.markers)
            // map.remove(self.createMark)
            // map.remove(self.lawyerMarkers)
            break
          case 16:
            removeBounds()
            map.remove(self.markers)
            // map.remove(self.createMark)
            // map.remove(self.lawyerMarkers)
            break
          default:
            removeBounds()
            map.remove(self.markers)
            // map.remove(self.lawyerMarkers)
        }
      })
    }
    function getMapZoom () {
      return map.getZoom()
    }
    function moveMap () {
      map.on('moveend', function () {
        map.getCity(function (data) {
          if (data['province'] && typeof data['province'] === 'string') {
            for (let i = 0; i < self.zoomCode.length; i++) {
              if (self.zoomCode[i].name === data.district) {
                if (getMapZoom() === 15) {
                  map.remove(self.markers)
                  // map.remove(self.lawyerMarkers)
                  // self.createStreetData(self.stract)
                }
              }
            }
          }
        })
      })
    }
    function init () {
      self.zoomCityShow()
      mapZoomShowCir()
      moveMap()
    }
    init()
  })
  if (history.pushState) {
    window.addEventListener('popstate', function () {
      if (self.showstr === true && self.geli === false) {
        history.replaceState(null, null, location.href.split('?')[0])
        self.pagenum = 1
        self.resuList = []
        self.totname = ''
        self.jd = ''
        self.towncode = ''
        self.search = ''
        self.stractname = ''
        self.stract = []
        self.stractt = []
        self.show = false
        self.sshow = false
        self.showstr = false
        self.area = '上海'
        self.number = self.standbynumber
        self.cod = ''
        self.tpid = '1309ace1040f457cb27f48d3b66e13cf'
        self.gePosition = [0, 0]
        self.qy = '区域筛选'
        self.jg = '机构类型筛选'
        self.lodshow = false
        self.qu = false
        self.qub = false
        self.quc = false
        self.jgshow = true
        self.lxshow = true
        self.tpage = 0
        self.toback = false
        self.nuab = ''
        self.maplod = false
        self.map.setZoom(11)
        self.map.remove(self.searchMarkers)
        self.map.clearMap()
        if (self.map.getZoom() === 11) {
          self.zoomCityShow('上海市')
        }
        self.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&zoneCode=&', {
          callbackQuery: 'jsonp'
        }).then(json => {
          self.zoomCode = json
        })
        return
      }
      if (self.sshow === true) {
        self.tpid = '1309ace1040f457cb27f48d3b66e13cf'
        self.stractname = ''
        self.sshow = false
        self.showstr = true
        self.geli = true
        setTimeout(() => {
          self.geli = false
        }, 0)
        return
      }
    })
  }
}

export const methods = {
  sho: function (index, item, num, code, name) {
    this.gePosition = [0, 0]
    history.pushState(null, null, location.href.split('?')[0] + '?' + 'street-' + index)
    this.qub = true
    this.toback = true
    this.stract = []
    this.stractname = ''
    this.jd = '街道筛选'
    this.number = num
    this.showstr = false
    this.sshow = false
    this.show = true
    this.cod = code
    this.area = name
    this.qu = false
    this.qy = name
    this.lodshow = true
    this.titNumber = true
    if (this.tpid === 'f2c12d3fe56845c79154dea5a90c8bb1') {
      this.resuList = []
      this.showstr = false
      this.sshow = false
      this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?pageSize=20&', {
        callbackQuery: 'jsonp',
        zoneCode: '' + this.cod + '',
        typeId: '' + this.tpid + ''
      }).then(json => {
        this.resuList = json
        this.tpage = this.resuList.length
        this.detailnum = json[0].totalPagetotalPage
        this.titNumber = true
        this.number = json.length * json[0].totalPage
        this.addMarker(json)
        setTimeout(() => {
          this.sshow = true
          this.lodshow = false
        }, 400)
      })
    } else {
      this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', { // 去街道
        callbackQuery: 'jsonp',
        zoneCode: '' + this.cod + '',
        typeId: '' + this.tpid + ''
      }).then(json => {
        this.stract = json
        let districtCenter
        if (json.length !== 0 && json[0].longitudeGD) {
          districtCenter = [json[0].longitudeGD, json[0].latitudeGD]
        }
        let num = 0
        if (json.length === 0) this.number = 0
        for (let i = 0; i < json.length; i++) {
          this.number = num += json[i].count
        }
        this.map.setZoomAndCenter(16, districtCenter)
        this.map.remove(this.markers)
        this.map.remove(this.lawyerMarkers)
        this.createStreetData(json)
        setTimeout(() => {
          this.showstr = true
          this.lodshow = false
        }, 400)
      })
    }
  },
  abaInner: function (json) {
    let len = json.length
    let lnglat = new AMap.LngLat(this.myPosition[0], this.myPosition[1])
    this.resuList = []
    this.resuList = json
    for (let i = 0; i < len; i++) {
      let num = parseInt(lnglat.distance([this.resuList[i].properties.longitudeGD, this.resuList[i].properties.latitudeGD]))
      let cont
      if (num >= 1000) {
        cont = (num / 1000) + '千米'
      } else {
        cont = num + '米'
      }
      this.resuList[i].distance = cont
    }
    this.sshow = true
    this.lodshow = false
  },
  aba: function (code, num, name, index, item, poss, isPosition) {
    this.gePosition = [0, 0]
    history.pushState(null, null, location.href.split('?')[0] + '?' + 'detail-' + index)
    this.position = [item.longitudeGD, item.latitudeGD]
    if (poss) {
      this.position = poss
    } else {
      this.position = [item.longitudeGD, item.latitudeGD]
    }
    this.pagenum = 1
    this.resuList = []
    this.jd = name
    this.towncode = code
    this.lxshow = false
    this.totname = name
    this.stractname = name
    this.showstr = false
    this.sshow = false
    this.lodshow = true
    this.number = num
    this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?pageSize=20', { // 去街道
      callbackQuery: 'jsonp',
      towncode: '' + code + '',
      zoneCode: '' + this.cod + '',
      typeId: '' + this.tpid + ''
    }).then(json => {
      // let len = json.length
      // let lnglat = new AMap.LngLat(this.myPosition[0], this.myPosition[1])
      this.resuList = json
      // for (let i = 0; i < len; i++) {
      //   let num = parseInt(lnglat.distance([this.resuList[i].properties.longitude, this.resuList[i].properties.latitude]))
      //   let cont
      //   if (num >= 1000) {
      //     cont = (num / 1000) + '千米'
      //   } else {
      //     cont = num + '米'
      //   }
      //   this.resuList[i].distance = cont
      // }
      this.tpage = this.resuList.length
      this.detailnum = json.length !== 0 ? json[0].totalPage : 0
      this.titNumber = true
      this.number = json.length !== 0 ? json[0].total : 0
      if (!isPosition) {
        this.addMarker(json)
      }
      let districtCenter
      if (json.length !== 0 && json[0].longitudeGD) {
        districtCenter = [json[0].longitudeGD, json[0].latitudeGD]
      }
      this.map.setZoomAndCenter(16, districtCenter)
      setTimeout(() => {
        this.sshow = true
        this.lodshow = false
      }, 400)
    })
  },
  ajaxup: function () {
    this.jgshow = false
    this.pagenum += 1
    this.sshow = false
    this.lodshow = true
    if (this.pagenum >= this.detailnum) {
      this.pagenum = this.detailnum
    }
    this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?&pageSize=20', {
      callbackQuery: 'jsonp',
      township: '' + this.totname + '',
      towncode: '' + this.towncode + '',
      zoneCode: '' + this.cod + '',
      typeId: '' + this.tpid + '',
      page: '' + this.pagenum + ''
    }).then(json => {
      let resu = json
      this.map.remove(this.markers)
      this.addMarker(json)
      this.resuList = resu
      this.jgshow = true
      setTimeout(() => {
        this.sshow = true
        this.lodshow = false
      }, 400)
    })
  },
  ajaxdown: function () {
    this.jgshow = false
    this.pagenum -= 1
    this.sshow = false
    this.lodshow = true
    if (this.pagenum <= 1) {
      this.pagenum = 1
    }
    this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?&pageSize=20', {
      callbackQuery: 'jsonp',
      township: '' + this.totname + '',
      zoneCode: '' + this.cod + '',
      typeId: '' + this.tpid + '',
      page: '' + this.pagenum + ''
    }).then(json => {
      let resu = json
      this.map.remove(this.markers)
      this.addMarker(json)
      this.resuList = resu
      this.jgshow = true
      setTimeout(() => {
        this.sshow = true
        this.lodshow = false
      }, 400)
    })
  },
  shob: function (name, id) {
    let zunnumber = 0
    this.pagenum = 1
    this.tpid = id
    this.jg = name
    // this.jd = '街道筛选'
    this.jgtext = name
    this.stractname = ''
    // this.towncode = ''
    // if (this.showstr && name === '公证处') {
    //   this.resuList = []
    //   this.showstr = false
    //   this.sshow = false
    //   this.lodshow = true
    //   this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?pageSize=20&', {
    //     callbackQuery: 'jsonp',
    //     zoneCode: '' + this.cod + '',
    //     typeId: '' + this.tpid + ''
    //   }).then(json => {
    //     this.resuList = json
    //     this.tpage = this.resuList.length
    //     this.detailnum = json[0].totalPage
    //     this.titNumber = true
    //     this.number = json.length * json[0].totalPage
    //     setTimeout(() => {
    //       this.sshow = true
    //       this.lodshow = false
    //     }, 400)
    //   })
    // }
    if (this.showstr) { // 街道级别筛选
      this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
        callbackQuery: 'jsonp',
        zoneCode: '' + this.cod + '',
        towncode: '' + this.towncode + '',
        typeId: '' + this.tpid + ''
      }).then(json => {
        this.stract = json
        let quyuleng = json.length
        if (quyuleng === 0) this.number = 0
        for (let i = 0; i < quyuleng; i++) {
          this.number = zunnumber += json[i].count
        }
        let districtCenter
        if (json.length !== 0 && json[0].longitudeGD) {
          districtCenter = [json[0].longitudeGD, json[0].latitudeGD]
        }
        this.map.setZoomAndCenter(16, districtCenter)
        this.map.remove(this.markers)
        this.map.remove(this.lawyerMarkers)
        this.createStreetData(json)
      })
      // this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
      //   callbackQuery: 'jsonp',
      //   towncode: '' + this.towncode + '',
      //   zoneCode: '' + this.cod + '',
      //   typeId: '' + this.tpid + ''
      // }).then(json => {
      //   this.zoomCode = json
      // })
    } else if (this.sshow) { // 详细级别筛选
      if (this.gePosition[0]) {
        this.cod = ''  // 清空code
        // this.tpid = '1309ace1040f457cb27f48d3b66e13cf' // 清空code
        let position = [this.gePosition[0], this.gePosition[1]]
        this.map.setZoomAndCenter(16, position)
        this.$jsonp(`https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/orgnearby?longitude=${this.gePosition[0]}&latitude=${this.gePosition[1]}`, {
          callbackQuery: 'jsonp',
          callbackName: 'jsonp',
          pageSize: '15',
          typeId: '' + this.tpid + ''
        }).then(json => {
          this.number = json.length
          this.tpage = 0
          this.abaInner(json)
          this.addMarkerp(json)
          let icon = new AMap.Icon({
            image: 'static/images/mark_local.png',
            size: new AMap.Size(25, 36)
          })
          let marker = new AMap.Marker({
            icon: icon,
            position: position,
            topWhenMouseOver: true,
            map: this.map
          })
          this.lawyerMarkers.push(marker)
          if (json.length >= 1) {
            let contJson = json[0]
            let inner = contJson.properties.name
            let address = contJson.properties.address
            let phone = contJson.properties.phone
            let position = '' + contJson.properties.longitudeGD + ',' + contJson.properties.latitudeGD + ''
            let tpid = contJson.typeId
            let id = contJson.id
            let tpname = contJson.typeName
            this.createWindow({
              inner: inner, // 名字
              address: address, // 地址
              phone: phone, // 电话
              tpid: tpid, // 机构类型
              id: id, // id
              tpname: tpname // 机构类型名称
            }, this)
            this.infowindow.open(this.map, position.split(','))
          }
        })
      } else {
        this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?pageSize=20&', {
          callbackQuery: 'jsonp',
          zoneCode: '' + this.cod + '',
          towncode: '' + this.towncode + '',
          typeId: '' + this.tpid + ''
        }).then(json => {
          this.addMarker(json)
          this.resuList = json
          this.tpage = this.resuList.length
          this.detailnum = json.length !== 0 ? json[0].totalPage : 0
          this.titNumber = true
          // this.number = this.tpage * this.detailnum
          this.number = json.length !== 0 ? json[0].total : 0
        })
        // this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
        //   callbackQuery: 'jsonp',
        //   zoneCode: '' + this.cod + '',
        //   towncode: '' + this.towncode + '',
        //   typeId: '' + this.tpid + ''
        // }).then(json => {
        //   this.zoomCode = json
        // })
      }
    } else {
      this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
        callbackQuery: 'jsonp',
        zoneCode: '' + this.cod + '',
        towncode: '' + this.towncode + '',
        typeId: '' + this.tpid + ''
      }).then(json => {
        if (this.cod === '') {
          this.zoomCode = json
          this.map.remove(this.markers)
          this.map.remove(this.lawyerMarkers)
          this.zoomCityShow()
        } else {
          this.stract = json
        }
        let jdlength = json.length
        if (jdlength === 0) this.number = 0
        for (let j = 0; j < jdlength; j++) {
          this.number = zunnumber += json[j].count
        }
      })
    }
  },
  aac: function (tet, event) {
    let kcd = event.keyCode
    if (kcd !== 37 && kcd !== 38 && kcd !== 39 && kcd !== 40) {
      this.butshow = false
    }
    let strlen = tet.length
    let fculen = this.screening.length
    if (kcd !== 38 && kcd !== 40 && kcd !== 13) {
      this.focusList = -1
    }
    if (kcd === 38) {
      this.focusList--
      if (this.newAutoArr.length >= 1) {
        if (this.oneSw) {
          if (this.focusList < 0) {
            this.focusList = this.newAutoArr.length - 1
            for (let c = 0; c < fculen; c++) {
              this.screening[c].kai = false
            }
            this.newAutoArr[this.newAutoArr.length - 1].kai = true
            this.oneSw = false
            this.twoSw = true
          } else {
            for (let c = 0; c < fculen; c++) {
              this.screening[c].kai = false
              this.screening[this.focusList].kai = true
              this.search = this.screening[this.focusList].name
            }
          }
        } else if (this.twoSw) {
          if (this.focusList < 0) {
            this.focusList = fculen - 1
            for (let i = 0; i < this.newAutoArr.length; i++) {
              this.newAutoArr[i].kai = false
            }
            this.screening[fculen - 1].kai = true
            this.oneSw = true
            this.twoSw = false
          } else {
            for (let i = 0; i < this.newAutoArr.length; i++) {
              this.newAutoArr[i].kai = false
              this.newAutoArr[this.focusList].kai = true
              this.search = this.newAutoArr[this.focusList].name
            }
          }
        }
      } else {
        if (this.focusList < 0) {
          this.focusList = fculen - 1
        }
        for (let c = 0; c < fculen; c++) {
          this.screening[c].kai = false
          this.screening[this.focusList].kai = true
          this.search = this.screening[this.focusList].name
        }
      }
    } else if (kcd === 40) {
      this.focusList++
      if (this.newAutoArr.length >= 1) {
        if (this.oneSw) {
          if (this.focusList >= fculen) {
            this.focusList = 0
            for (let c = 0; c < fculen; c++) {
              this.screening[c].kai = false
            }
            this.newAutoArr[0].kai = true
            this.oneSw = false
            this.twoSw = true
          } else {
            for (let c = 0; c < fculen; c++) {
              this.screening[c].kai = false
              this.screening[this.focusList].kai = true
              this.search = this.screening[this.focusList].name
            }
          }
        } else if (this.twoSw) {
          if (this.focusList >= this.newAutoArr.length) {
            this.focusList = 0
            for (let i = 0; i < this.newAutoArr.length; i++) {
              this.newAutoArr[i].kai = false
            }
            this.screening[0].kai = true
            this.oneSw = true
            this.twoSw = false
          } else {
            for (let i = 0; i < this.newAutoArr.length; i++) {
              this.newAutoArr[i].kai = false
              this.newAutoArr[this.focusList].kai = true
              this.search = this.newAutoArr[this.focusList].name
            }
          }
        }
      } else {
        if (this.focusList >= fculen) {
          this.focusList = 0
        }
        for (let c = 0; c < fculen; c++) {
          this.screening[c].kai = false
          this.screening[this.focusList].kai = true
          this.search = this.screening[this.focusList].name
        }
      }
    } else if (kcd === 27) {
      this.search = ''
      this.innbool = false
      return
    } else if (kcd === 13) {
      this.innbool = false
      if (this.twoSw) {
        let item = this.newAutoArr[this.focusList]
        this.stractname = item.name
        this.cod = ''  // 清空code
        // this.tpid = '1309ace1040f457cb27f48d3b66e13cf' // 清空code
        if (item.lat !== '') {
          let position = [item.lng, item.lat]
          this.myPosition = position
          this.gePosition = position
          this.map.setZoomAndCenter(16, position)
          this.$jsonp(`https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/orgnearby?longitude=${item.lng}&latitude=${item.lat}`, {
            callbackQuery: 'jsonp',
            callbackName: 'jsonp',
            pageSize: '15',
            typeId: '' + this.tpid + ''
          }).then(json => {
            this.number = json.length
            this.tpage = 0
            this.abaInner(json)
            this.addMarkerp(json)
            let icon = new AMap.Icon({
              image: 'static/images/mark_local.png',
              size: new AMap.Size(25, 36)
            })
            let marker = new AMap.Marker({
              icon: icon,
              position: position,
              topWhenMouseOver: true,
              map: this.map
            })
            this.lawyerMarkers.push(marker)
            if (json.length >= 1) {
              let contJson = json[0]
              let inner = contJson.properties.name
              let address = contJson.properties.address
              let phone = contJson.properties.phone
              let position = '' + contJson.properties.longitudeGD + ',' + contJson.properties.latitudeGD + ''
              let tpid = contJson.typeId
              let id = contJson.id
              let tpname = contJson.typeName
              this.createWindow({
                inner: inner, // 名字
                address: address, // 地址
                phone: phone, // 电话
                tpid: tpid, // 机构类型
                id: id, // id
                tpname: tpname // 机构类型名称
              }, this)
              this.infowindow.open(this.map, position.split(','))
            }
          })
        }
        return
      } else {
        // this.newAutoArr = []
        // this.oneSw = true
        // this.twoSw = false
        // this.newAShow = false
        if (this.focusList < 0) {
          this.focusList = 0
          this.screening[0].kai = true
        }
        this.focusList = this.focusList ? this.focusList : 0
        this.search = this.screening[this.focusList].name
        this.screeninga.unshift({name: this.search, kai: false})
        let lablen = this.screeninga.length
        this.screeninga.splice(7, lablen - 7)
        localStorage.arc = JSON.stringify(this.screeninga)
        this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?', {
          callbackQuery: 'jsonp',
          keyWord: '' + this.search + '',
          typeId: '' + this.tpid + ''
        }).then(json => {
          this.addMarker(json)
          let jd = json[0].properties
          let name = json[0].typeName
          let id = json[0].id
          this.accurate.name = jd.name
          this.accurate.j = jd.longitudeGD
          this.accurate.w = jd.latitudeGD
          this.accurate.phone = jd.phone
          this.accurate.address = jd.address || '暂无地址'
          if (!this.accurate.j) {
            alert('没有坐标')
            return
          }
          this.map.setZoomAndCenter(16, [this.accurate.j, this.accurate.w])
          this.createWindow({
            inner: this.search,
            address: this.accurate.address,
            phone: this.accurate.phone,
            id: id,
            tpname: name
          }, this)
          this.infowindow.open(this.map, [this.accurate.j, this.accurate.w])
        })
        return
      }
    }
    if (strlen >= 2 && kcd !== 38 && kcd !== 40) {
      if (this.search === '') {
        this.innbool = false
      } else {
        this.innbool = true
      }
      this.innbool = true
      let val = tet.trim()
      if (val === '') {
        this.newAutoArr = []
        this.screening = []
        this.innbool = false
        return
      }
      this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?&page=1&pageSize=10', {
        callbackQuery: 'jsonp',
        keyWord: '' + val + '',
        typeId: '' + this.tpid + ''
      }).then(json => {
        let iner = json
        this.screening = []
        for (let i = 0; i < iner.length; i++) {
          this.screening.push({name: iner[i].properties.name, kai: false, tpn: iner[i].typeName})
          if (i >= 5) {
            break
          }
        }
        // let leen = this.screening.length
        // this.screening.splice(10, leen - 10)
        // if (kcd !== 38 && kcd !== 40 && kcd !== 13) {
        //   this.focusList = -1
        // }
        // if (kcd === 38) {
        //   this.focusList--
        //   if (this.focusList < 0) {
        //     this.focusList = leen - 1
        //   }
        //   for (let c = 0; c < leen; c++) {
        //     this.screening[c].kai = false
        //     this.screening[this.focusList].kai = true
        //     this.search = this.screening[this.focusList].name
        //   }
        // } else if (kcd === 40) {
        //   this.focusList++
        //   console.log(this.focusList)
        //   if (this.focusList >= leen) {
        //     // this.focusList = 0
        //     console.log(this.focusList)
        //     for (let i = 0; i < lenNew; i++) {
        //       this.newAutoArr[i].kai = false
        //       this.newAutoArr[this.focusList].kai = true
        //       this.search = this.newAutoArr[this.focusList].name
        //     }
        //   } else {
        //     for (let c = 0; c < leen; c++) {
        //       this.screening[c].kai = false
        //       this.screening[this.focusList].kai = true
        //       this.search = this.screening[this.focusList].name
        //     }
        //   }
        // }
        this.newAuto(tet).then(js => {
          this.newAShow = true
          this.newAutoArr = []
          let len = js.tips.length
          for (var i = 0; i < len; i++) {
            if (js.tips[i].location) {
              this.newAutoArr.push({name: js.tips[i].name, lat: js.tips[i].location.lat, lng: js.tips[i].location.lng, kai: false, auto: true})
            } else {
              this.newAutoArr.push({name: js.tips[i].name, lat: '', lng: '', kai: false, auto: true})
            }
          }
        })
      })
    } else {
      return
    }
  },
  newAab: function (item) {
    this.stractname = item.name
    this.cod = ''  // 清空code
    // this.tpid = '1309ace1040f457cb27f48d3b66e13cf' // 清空code
    if (item.lat !== '') {
      let position = [item.lng, item.lat]
      this.gePosition = position
      this.myPosition = position
      this.map.setZoomAndCenter(16, position)
      this.$jsonp(`https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/orgnearby?longitude=${item.lng}&latitude=${item.lat}`, {
        callbackQuery: 'jsonp',
        callbackName: 'jsonp',
        pageSize: '15',
        typeId: '' + this.tpid + ''
      }).then(json => {
        this.number = json.length
        this.tpage = 0
        this.abaInner(json)
        this.addMarkerp(json)
        let icon = new AMap.Icon({
          image: 'static/images/mark_local.png',
          size: new AMap.Size(25, 36)
        })
        let marker = new AMap.Marker({
          icon: icon,
          position: position,
          topWhenMouseOver: true,
          map: this.map
        })
        this.lawyerMarkers.push(marker)
        if (json.length >= 1) {
          let contJson = json[0]
          let inner = contJson.properties.name
          let address = contJson.properties.address
          let phone = contJson.properties.phone
          let position = '' + contJson.properties.longitudeGD + ',' + contJson.properties.latitudeGD + ''
          let tpid = contJson.typeId
          let id = contJson.id
          let tpname = contJson.typeName
          this.createWindow({
            inner: inner, // 名字
            address: address, // 地址
            phone: phone, // 电话
            tpid: tpid, // 机构类型
            id: id, // id
            tpname: tpname // 机构类型名称
          }, this)
          this.infowindow.open(this.map, position.split(','))
        }
      })
    }
  },
  aab: function (inner) {
    this.innbool = false
    if (inner === '') {
      return
    }
    this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?', {
      callbackQuery: 'jsonp',
      keyWord: '' + inner + '',
      typeId: '' + this.tpid + ''
    }).then(json => {
      this.addMarkers(json)
      let jd = json[0].properties
      let name = json[0].typeName
      let id = json[0].id
      this.accurate.name = jd.name
      this.accurate.j = jd.longitudeGD
      this.accurate.w = jd.latitudeGD
      this.accurate.phone = jd.phone
      this.accurate.address = jd.address || '暂无地址'
      this.map.remove(this.searchMarkers)
      let div = document.createElement('div')
      let position = [this.accurate.j, this.accurate.w + 0.005]
      div.className = 'dot'
      if (!this.accurate.j) {
        alert('没有坐标')
        return
      }
      this.map.setZoomAndCenter(16, position)
      this.createWindow({
        inner: inner,
        address: this.accurate.address,
        phone: this.accurate.phone,
        id: id,
        tpname: name
      }, this)
      this.infowindow.open(this.map, [this.accurate.j, this.accurate.w])
      div.onclick = function () {
        this.infowindow.open(this.map, [this.accurate.j, this.accurate.w])
      }
    })
    if (localStorage.arc) {
      this.screeninga = JSON.parse(localStorage.arc)
      this.screeninga.unshift({name: inner, kai: false})
      let lablen = this.screeninga.length
      this.screeninga.splice(7, lablen - 7)
      localStorage.arc = JSON.stringify(this.screeninga)
    } else {
      this.screeninga.unshift({name: inner, kai: false})
      let lablen = this.screeninga.length
      this.screeninga.splice(7, lablen - 7)
      localStorage.arc = JSON.stringify(this.screeninga)
    }
  },
  djshow: function () {
    this.newAutoArr = []
    this.oneSw = true
    this.twoSw = false
    this.newAShow = false
    this.butshow = true
    if (localStorage.arc) {
      this.screeninga = JSON.parse(localStorage.arc)
      let len = this.screeninga.length
      let cc = []
      for (let i = 0; i < len; i++) {
        let inam = this.screeninga[i].name
        let kaiguan = true
        for (let j = i + 1; j < len; j++) {
          let jnam = this.screeninga[j].name
          if (inam === jnam) {
            kaiguan = false
            break
          }
        }
        if (kaiguan) {
          cc.push({name: inam, kai: false})
        }
      }
      this.screeninga = cc
      this.screening = this.screeninga
      localStorage.arc = JSON.stringify(this.screeninga)
      this.innbool = true
    } else {
      return
    }
  },
  hoverCityOver: function (item) {
    let ele = document.getElementsByClassName('circle')
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].innerHTML.replace(/<.*> [0-9]*/g, '') === item.name) {
        ele[i].className += ' hover'
      }
    }
  },
  hoverCityOut: function (item) {
    let ele = document.getElementsByClassName('circle')
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].innerHTML.replace(/<.*> [0-9]*/g, '') === item.name) {
        ele[i].className = 'circle'
      }
    }
  },
  fouc: function () {
    setTimeout(() => {
      this.innbool = false
      this.butshow = false
      this.newAutoArr = ''
      this.oneSw = true
      this.twoSw = false
      this.newAShow = false
    }, 300)
  },
  clear: function () {
    history.replaceState(null, null, location.href.split('?')[0])
    this.pagenum = 1
    this.geli = false
    this.resuList = []
    this.totname = ''
    this.jd = ''
    this.towncode = ''
    this.search = ''
    this.stractname = ''
    this.stract = []
    this.stractt = []
    this.show = false
    this.sshow = false
    this.showstr = false
    this.area = '上海'
    this.number = this.standbynumber
    this.cod = ''
    this.tpid = '1309ace1040f457cb27f48d3b66e13cf'
    this.gePosition = [0, 0]
    this.qy = '区域筛选'
    this.jg = '机构类型筛选'
    this.lodshow = false
    this.qu = false
    this.qub = false
    this.quc = false
    this.jgshow = true
    this.lxshow = true
    this.tpage = 0
    this.nuab = ''
    this.toback = false
    this.maplod = false
    this.map.setZoom(11)
    this.newAutoArr = []
    this.oneSw = true
    this.twoSw = false
    this.newAShow = false
    this.map.remove(this.searchMarkers)
    this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&zoneCode=&', {
      callbackQuery: 'jsonp',
      towncode: '' + this.towncode + '',
      typeId: '' + this.tpid + ''
    }).then(json => {
      this.zoomCode = json
      this.map.remove(this.markers)
      this.map.remove(this.lawyerMarkers)
      this.zoomCityShow()
    })
  },
  clearf: function () {
    let nnum = 0
    this.tpid = '1309ace1040f457cb27f48d3b66e13cf'
    this.jg = '全部类型'
    this.jgtext = '法律服务机构'
    this.resuList = []
    if (this.showstr && !this.sshow) {
      this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1', {
        callbackQuery: 'jsonp',
        towncode: '' + this.towncode + '',
        zoneCode: '' + this.cod + '',
        typeId: '' + this.tpid + ''
      }).then(json => {
        this.stract = json
        let leng = json.length
        for (let i = 0; i < leng; i++) {
          this.number = (nnum += json[i].count)
        }
        this.map.remove(this.markers)
        this.map.remove(this.lawyerMarkers)
        this.createStreetData(json)
      })
    } else if (!this.showstr && this.sshow) {
      this.stractname = ''
      if (this.gePosition[0]) {
        this.cod = ''  // 清空code
        // this.tpid = '1309ace1040f457cb27f48d3b66e13cf' // 清空code
        let position = [this.gePosition[0], this.gePosition[1]]
        this.map.setZoomAndCenter(16, position)
        this.$jsonp(`https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/orgnearby?longitude=${this.gePosition[0]}&latitude=${this.gePosition[1]}`, {
          callbackQuery: 'jsonp',
          callbackName: 'jsonp',
          pageSize: '15',
          typeId: '' + this.tpid + ''
        }).then(json => {
          this.number = json.length
          this.tpage = 0
          this.abaInner(json)
          this.addMarkerp(json)
          let icon = new AMap.Icon({
            image: 'static/images/mark_local.png',
            size: new AMap.Size(25, 36)
          })
          let marker = new AMap.Marker({
            icon: icon,
            position: position,
            topWhenMouseOver: true,
            map: this.map
          })
          this.lawyerMarkers.push(marker)
          if (json.length >= 1) {
            let contJson = json[0]
            let inner = contJson.properties.name
            let address = contJson.properties.address
            let phone = contJson.properties.phone
            let position = '' + contJson.properties.longitudeGD + ',' + contJson.properties.latitudeGD + ''
            let tpid = contJson.typeId
            let id = contJson.id
            let tpname = contJson.typeName
            this.createWindow({
              inner: inner, // 名字
              address: address, // 地址
              phone: phone, // 电话
              tpid: tpid, // 机构类型
              id: id, // id
              tpname: tpname // 机构类型名称
            }, this)
            this.infowindow.open(this.map, position.split(','))
          }
        })
      } else {
        this.stractname = ''
        this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapdata?pageSize=20&', {
          callbackQuery: 'jsonp',
          zoneCode: '' + this.cod + '',
          towncode: '' + this.towncode + '',
          typeId: '' + this.tpid + ''
        }).then(json => {
          this.addMarker(json)
          this.resuList = json
          this.tpage = this.resuList.length
          this.titNumber = true
          this.detailnum = json[0].totalPage
          // this.number = this.tpage * this.detailnum
          this.number = json.length !== 0 ? json[0].total : 0
          setTimeout(() => {
            this.sshow = true
            this.lodshow = false
          }, 400)
        })
        // this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
        //   callbackQuery: 'jsonp',
        //   towncode: '' + this.towncode + '',
        //   zoneCode: '' + this.cod + '',
        //   typeId: '' + this.tpid + ''
        // }).then(json => {
        //   this.stract = json
        //   // let leng = json.length
        //   this.number = json.length !== 0 ? json[0].count : 0
        //   // for (let i = 0; i < leng; i++) {
        //   //   this.number = (nnum += json[i].count)
        //   // }
        // })
      }
    } else {
      this.cod = ''
      this.pagenum = 1
      this.search = ''
      this.area = '上海'
      this.number = this.standbynumber
      this.jg = '全部类型'
      this.lodshow = false
      this.qu = false
      this.map.setZoom(11)
      this.towncode = ''
      this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&zoneCode=&', {
        callbackQuery: 'jsonp',
        towncode: '' + this.towncode + '',
        zoneCode: '' + this.cod + '',
        typeId: '' + this.tpid + ''
      }).then(json => {
        this.zoomCode = json
        this.map.remove(this.markers)
        this.map.remove(this.lawyerMarkers)
        this.zoomCityShow()
      })
    }
  },
  clearl: function () {
    this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
      callbackQuery: 'jsonp',
      towncode: '' + this.towncode + '',
      typeId: '' + this.tpid + ''
    }).then(json => {
      this.zoomCode = json
      this.map.remove(this.markers)
      this.map.remove(this.lawyerMarkers)
      this.map.setZoom(11)
      this.zoomCityShow()
    })
    this.jgtext = '法律服务机构'
    this.pagenum = 1
    this.totname = ''
    this.jd = ''
    this.stract = []
    this.show = false
    this.sshow = false
    this.showstr = false
    this.area = '上海'
    this.number = this.standbynumber
    this.cod = ''
    this.qy = '区域筛选'
    this.jg = '机构类型筛选'
    this.tpid = '1309ace1040f457cb27f48d3b66e13cf'
    this.gePosition = [0, 0]
    this.towncode = ''
    this.qu = false
    this.qub = false
    this.quc = false
    this.resuList = []
  },
  clearjd: function () {
    let nnum = 0
    this.resuList = []
    this.jd = '全部街道'
    this.stractname = ''
    this.tpid = '1309ace1040f457cb27f48d3b66e13cf'
    this.gePosition = [0, 0]
    this.jg = '机构类型筛选'
    this.jgtext = '法律服务机构'
    this.lodshow = true
    this.sshow = false
    this.showstr = false
    this.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&', {
      callbackQuery: 'jsonp',
      zoneCode: '' + this.cod + '',
      towncode: '' + this.towncode + '',
      typeId: '' + this.tpid + ''
    }).then(json => {
      this.stract = json
      let leng = json.length
      for (let i = 0; i < leng; i++) {
        this.number = (nnum += json[i].count)
      }
      setTimeout(() => {
        this.showstr = true
        this.lodshow = false
      }, 400)
    })
  },
  back: function () {
    let self = this
    if (self.showstr === true && self.geli === false) {
      history.replaceState(null, null, location.href.split('?')[0])
      self.pagenum = 1
      self.resuList = []
      self.totname = ''
      self.jd = ''
      self.towncode = ''
      self.search = ''
      self.stractname = ''
      self.stract = []
      self.stractt = []
      self.show = false
      self.sshow = false
      self.showstr = false
      self.area = '上海'
      self.number = self.standbynumber
      self.cod = ''
      self.tpid = '1309ace1040f457cb27f48d3b66e13cf'
      self.qy = '区域筛选'
      self.jg = '机构类型筛选'
      self.lodshow = false
      self.qu = false
      self.qub = false
      self.quc = false
      self.jgshow = true
      self.lxshow = true
      self.tpage = 0
      self.nuab = ''
      self.maplod = false
      self.toback = false
      self.map.setZoom(11)
      self.map.remove(self.searchMarkers)
      self.map.clearMap()
      if (self.map.getZoom() === 11) {
        self.zoomCityShow('上海市')
      }
      self.$jsonp('https://sh.12348.gov.cn/service/rest/orgstruct.Map/collection/mapgroupdata?pageSize=-1&zoneCode=&', {
        towncode: '' + this.towncode + '',
        callbackQuery: 'jsonp'
      }).then(json => {
        self.zoomCode = json
      })
      return
    }
    if (self.sshow === true) {
      self.tpid = '1309ace1040f457cb27f48d3b66e13cf'
      self.stractname = ''
      self.sshow = false
      self.showstr = true
      self.geli = true
      setTimeout(() => {
        self.geli = false
      }, 0)
      return
    }
  }
}



// WEBPACK FOOTER //
// ./src/data.js